import { call, put, take } from 'redux-saga/effects';
import api from 'services';
import * as actionTypes from 'constants/ActionTypes';
import moment from 'moment';

/**
 * Get statistics emails
 * */
export function* getStatisticsEmails(from, until, isWorkingHours) {
    const response = yield call(api.getStatisticsEmails, from, until, isWorkingHours);

    if (response.status === 200) {
        yield put({
            type: actionTypes.GET_STATISTICS_EMAILS.SUCCESS,
            data: response.data,
        });
    }

    yield put({
        type: actionTypes.GET_STATISTICS_EMAILS.FAILURE,
        errors: response.errors,
    });
}

export function* watchGetStatisticsEmails() {
    while (true) {
        const { from, until, isWorkingHours } = yield take(actionTypes.GET_STATISTICS_EMAILS.REQUEST);
        yield call(getStatisticsEmails, from, until, isWorkingHours);
    }
}

export default [
    watchGetStatisticsEmails,
];



// WEBPACK FOOTER //
// ./app/sagas/statistics/emails.js